import { LabeledData } from '@gorila-shared-ui/components';
import { USER_TYPES } from '../../constants/users';
import { User } from '../../types/user';
import { PermissionTree } from '../shared/permissionTree/PermissionTree';

type Props = {
  user: User;
};
export function UserInfo({ user }: Readonly<Props>) {
  const labelWidth = '190px';
  return (
    <>
      {user.email && (
        <LabeledData
          label="Correo electrónico:"
          content={user.email}
          labelWidth={labelWidth}
        />
      )}
      {user.userType && (
        <LabeledData
          label="Rol:"
          content={USER_TYPES[user.userType]}
          labelWidth={labelWidth}
        />
      )}
      {user.pusherKey && (
        <LabeledData
          label="Clave pusher:"
          content={user.pusherKey}
          labelWidth={labelWidth}
        />
      )}
      {user.pusherStatus !== undefined && (
        <LabeledData
          label="Estado pusher:"
          content={user.pusherStatus ? 'Conectado' : 'Desconectado'}
          labelWidth={labelWidth}
        />
      )}
      {user.client && (
        <LabeledData
          label="Cliente:"
          content={user.client.name}
          labelWidth={labelWidth}
        />
      )}
      {user.subClient && (
        <LabeledData
          label="Subcliente:"
          content={user.subClient.name}
          labelWidth={labelWidth}
        />
      )}
      {user.subAccount && (
        <LabeledData
          label="Subcuenta:"
          content={user.subAccount.name}
          labelWidth={labelWidth}
        />
      )}
      {user.permissions && (
        <PermissionTree
          userPermissions={user.permissions}
          userId={user._id}
          disableScroll
          useFilteredPermission
        />
      )}
    </>
  );
}
